/**
 * @file Sums the amounts of an investment's sub-investments.
 */
import { getFormattedDecimalValue } from "@components/Amount";

type SubInvestment = {
  amount: number;
};

type Investment = {
  investments?: SubInvestment[];
};

/**
 * Sums the amounts of an investment's sub-investments into a single total.
 */
const computeInvestmentAmount = (investment: Investment): number => {
  const { investments = [] } = investment;

  const totalAmount = investments
    .map(({ amount }) => amount)
    .reduce((total, amount) => getFormattedDecimalValue(total, amount, "plus"), 0);

  return totalAmount;
};

export default computeInvestmentAmount;
